<template>
<div class="sidebar-group">
  <SidebarItem
    @click="toggleGroup"
    :icon="group.icon"
    :isDisabled="group.isDisabled"
    :tag="group.tag"
    :id="submenuId"
    aria-haspopup="true"
    :aria-expanded="String(isActive)"
  >
    <span class="sr-only">{{ !isActive ? $t('a11y.openDropdown') : $t('a11y.closeDropdown') }}</span>
    {{ $t(group.name_i18n) || group.name }}
  </SidebarItem>
  <ul
    v-if="isActive"
    class="sidebar-group__submenu"
    :aria-labelledby="submenuId"
  >
    <li
      v-for="(groupItem, index) in group.submenu"
      :key="index"
      class="sidebar-group__submenu-item"
    >
      <SidebarItem
        :to="groupItem.url"
        :href="groupItem.externalUrl"
        :target="groupItem.target"
        :isDisabled="groupItem.isDisabled"
        :tag="groupItem.tag"
      >
        {{ $t(groupItem.name_i18n) || groupItem.name }}
      </SidebarItem>
    </li>
  </ul>
</div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'
export default {
  name: 'SidebarGroup',
  components: {
    SidebarItem
  },
  props: {
    group: {
      type: Object
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    this.checkIsActive()
  },
  watch: {
    '$route'() {
      this.checkIsActive()
    }
  },
  computed: {
    submenuId() {
      return `submenu-${this._uid}`
    }
  },
  methods: {
    checkIsActive() {
      const activeRoute = this.group.submenu.find((item) => {
        const isSameRoute = this.$route.path.slice(1).includes(item.url.slice(1))

        return isSameRoute
      })
      this.isActive = !!activeRoute
    },
    toggleGroup() {
      if (this.isActive) {
        this.isActive = false
        return
      }
      this.isActive = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuesax/_variables.scss';

.sidebar-group {
  padding: 0;
  margin: 0;
  list-style-type: none;
  width: 100%;
  display: flex;
  flex-direction: column;

  &__submenu {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }

  &__submenu-item {
    padding: 0;
    margin: 0;
    font-size: $font-size-small;
  }
}
</style>
